















import {Vue, Component, Prop} from 'vue-property-decorator'
import NcpTableBodyHead from '@/components/table/tbody/NcpTableBodyHead.vue';
import { toI18n } from '@/utils/commonUtils';

interface ThData {
	content?: string,
}

interface TdData {
	content?: string,
	labelName?: string
  style?: string,
  class?: string,
  isHtml?: boolean,
}

interface TbodyContentData {
	thData: ThData,
	tdData: TdData,
}

@Component({
	components: {
		NcpTableBodyHead
	},
})
export default class NcpTableBody extends Vue {
	@Prop() private tbodyHeadData!: string[]
	@Prop() private tbodyContentData!: TbodyContentData[]

	public toI18n(needToI18nStr: string): string {
		return toI18n(this.$t(needToI18nStr));
	}
}

